module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticStyle: {
      "margin-left": "3%",
      "margin-right": "3%",
      "max-width": "94%"
    },
    attrs: {
      "quoteDetails": "",
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "paddingBottomNone",
    attrs: {
      "lg6": ""
    }
  }, [_c('strong', [_vm._v("Quote Date: ")]), _vm._v(" "), (_vm.singleQuoteData.quote.quote_date) ? _c('span', [_vm._v("  " + _vm._s(_vm.singleQuoteData.quote.quote_date))]) : _c('span', [_vm._v("  ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "2px",
      "clear": "both"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Customer Name:")]), _vm._v("  " + _vm._s(_vm.singleQuoteData.quote.customer_name) + "\n        "), _c('div', {
    staticStyle: {
      "margin-bottom": "2px",
      "clear": "both"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Originator Name:")]), _vm._v(" "), (_vm.singleQuoteData.quote.originator_name) ? _c('span', [_vm._v("  " + _vm._s(_vm.singleQuoteData.quote.originator_name))]) : _c('span', [_vm._v("  " + _vm._s(_vm.singleQuoteData.quote.orig_name))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "paddingBottomNone",
    attrs: {
      "lg6": ""
    }
  }, [_c('strong', [_vm._v("Sales Order Number:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fncShowSalesOrderNumber(_vm.singleQuoteData.quote.sales_order_number)))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "2px",
      "clear": "both"
    }
  }), _vm._v(" "), (_vm.globalModalParams.quoteDetails[0].deliveryType != '') ? _c('strong', [_vm._v("Delivery Type:")]) : _vm._e(), _vm._v(" "), (_vm.globalModalParams.quoteDetails[0].deliveryType != '') ? _c('span', [_vm._v(_vm._s(_vm.globalModalParams.quoteDetails[0].deliveryType))]) : _vm._e(), _vm._v(" "), (_vm.globalModalParams.quoteDetails[0].deliveryType != '') ? _c('div', {
    staticStyle: {
      "margin-bottom": "2px",
      "clear": "both"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.globalModalParams.quoteDetails[0].addressDetails) ? _c('strong', {
    domProps: {
      "innerHTML": _vm._s(_vm.fncGetLabel(_vm.globalModalParams.quoteDetails[0].deliveryType))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.globalModalParams.quoteDetails[0].addressDetails) ? _c('span', [_vm._v(_vm._s(_vm.globalModalParams.quoteDetails[0].addressDetails))]) : _vm._e(), _vm._v(" "), (_vm.globalModalParams.quoteDetails[0].addressDetails) ? _c('div', {
    staticStyle: {
      "margin-bottom": "2px",
      "clear": "both"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.globalModalParams.quoteDetails[0].billingAddress != '') ? _c('strong', [_vm._v("Billing Address:")]) : _vm._e(), _vm._v(" "), (_vm.globalModalParams.quoteDetails[0].billingAddress != '') ? _c('span', [_vm._v(_vm._s(_vm.globalModalParams.quoteDetails[0].billingAddress))]) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    staticClass: "userInfo",
    attrs: {
      "lg12": ""
    }
  }, [_c('v-data-table', {
    staticClass: "middleTable minTable",
    staticStyle: {
      "font-size": "10px"
    },
    attrs: {
      "search": _vm.search,
      "items": _vm.singleQuoteData.details,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "middle"
        }, [_c('th', {
          staticStyle: {
            "border": "1px solid #fff"
          }
        }, [_vm._v("ITEM")]), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('TRANSPORT_MODULE') !== -1) ? _c('th', {
          staticStyle: {
            "border": "1px solid #fff"
          },
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v("QUANTITY")]) : _c('th', {
          staticStyle: {
            "border": "1px solid #fff"
          }
        }, [_vm._v("QUANTITY")]), _vm._v(" "), _c('th', {
          staticStyle: {
            "border": "1px solid #fff"
          }
        }, [_vm._v("UOM")]), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') !== -1) ? _c('th', {
          staticStyle: {
            "border": "1px solid #fff"
          },
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v("UNIT PRICE")]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') === -1) ? _c('th', {
          staticStyle: {
            "border": "1px solid #fff"
          }
        }, [_vm._v("UNIT PRICE")]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') !== -1) ? _c('th', {
          staticStyle: {
            "border": "1px solid #fff"
          },
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v("TOTAL PRICE")]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') === -1) ? _c('th', {
          staticStyle: {
            "border": "1px solid #fff"
          }
        }, [_vm._v("TOTAL PRICE")]) : _vm._e()]), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') !== -1) ? _c('tr', {
          staticClass: "smaller middle"
        }, [_c('th', {
          staticStyle: {
            "border": "1px solid #fff"
          }
        }), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('TRANSPORT_MODULE') !== -1) ? _c('th', {
          staticStyle: {
            "border": "1px solid #fff"
          }
        }, [_vm._v("Requested")]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('TRANSPORT_MODULE') !== -1) ? _c('th', {
          staticStyle: {
            "border": "1px solid #fff"
          }
        }, [_vm._v("Actual")]) : _c('th', {
          staticStyle: {
            "border": "1px solid #fff"
          },
          attrs: {
            "width": "14%"
          }
        }), _vm._v(" "), _c('th', {
          staticStyle: {
            "border": "1px solid #fff"
          }
        }), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') !== -1) ? _c('th', {
          staticStyle: {
            "border": "1px solid #fff"
          }
        }, [_vm._v("Gross")]) : _vm._e(), _vm._v(" "), _c('th', {
          staticStyle: {
            "border": "1px solid #fff"
          }
        }, [_vm._v("Nett")]), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') !== -1) ? _c('th', {
          staticStyle: {
            "border": "1px solid #fff"
          }
        }, [_vm._v("Gross")]) : _vm._e(), _vm._v(" "), _c('th', {
          staticStyle: {
            "border": "1px solid #fff"
          }
        }, [_vm._v("Nett")])]) : _vm._e()]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [(_vm.linkedProps.indexOf(props.item.p_key.toString()) == -1 && _vm.fncIsParent(props.item) == false) ? _c('td', {
          domProps: {
            "innerHTML": _vm._s(_vm.fncFilterNameFull(props.item, props.item.name, false))
          }
        }) : _c('td', {
          domProps: {
            "innerHTML": _vm._s(_vm.fncFilterNameFull(props.item, props.item.name, true))
          }
        }), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('TRANSPORT_MODULE') !== -1) ? _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.quantity))]) : _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.quantity))]), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('TRANSPORT_MODULE') !== -1) ? _c('td', {
          staticClass: "text-xs-right v-else "
        }, [_vm._v(_vm._s(props.item.quantity_calc))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.fncFilterName(props.item.uom, false)))]), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') !== -1) ? _c('td', {
          staticClass: "text-xs-right "
        }, [_vm._v(_vm._s(_vm.fncFilterPrice(props.item.price)))]) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right "
        }, [_vm._v(_vm._s(_vm.fncFormatNett(props.item.price, props.item.discount)))]), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') !== -1) ? _c('td', {
          staticClass: "text-xs-right "
        }, [_vm._v(_vm._s(_vm.fncFormatTotal(props.item.price, props.item.quantity_calc)))]) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right "
        }, [_vm._v(_vm._s(_vm.fncFormatTotalNett(props.item.price, props.item.quantity_calc, props.item.discount, props.item.quantity)))])]
      }
    }])
  }, [_vm._v(" "), _vm._v(" "), (_vm.objAuthorize.manufacturer != '385889803' && _vm.objAuthorize.manufacturer != '16777962') ? _c('template', {
    staticStyle: {
      "padding-bottom": "10px",
      "margin-top": "40px"
    },
    slot: "footer"
  }, [_c('tr', {
    staticStyle: {
      "font-size": "12px !important",
      "border": "none !important",
      "background-color": "#fff !important",
      "background": "#fff !important",
      "color": "#000"
    }
  }, [(_vm.objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') !== -1) ? _c('td', {
    staticClass: "text-xs-right",
    staticStyle: {
      "text-align": "right !important"
    },
    attrs: {
      "colspan": "7"
    }
  }, [_c('strong', [_vm._v("NETT TOTAL")])]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') === -1) ? _c('td', {
    staticClass: "text-xs-right",
    staticStyle: {
      "text-align": "right !important"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_c('strong', [_vm._v("NETT TOTAL")])]) : _vm._e(), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right !important",
      "padding-right": "2%",
      "border-top": "1px solid #333 !important"
    }
  }, [_vm._v(_vm._s(_vm.fncTotalNett()))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "font-size": "12px !important",
      "border": "none !important",
      "background-color": "#fff !important",
      "background": "#fff !important",
      "color": "#000"
    }
  }, [(_vm.objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') !== -1) ? _c('td', {
    staticStyle: {
      "text-align": "right !important"
    },
    attrs: {
      "colspan": "7"
    }
  }, [_c('strong', [_vm._v("VAT @ 15%")])]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') === -1) ? _c('td', {
    staticStyle: {
      "text-align": "right !important"
    }
  }, [_c('strong', [_vm._v("VAT @ 15%")])]) : _vm._e(), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right !important",
      "padding-right": "2%",
      "border-bottom": "1px solid #333 !important"
    }
  }, [_vm._v(_vm._s(_vm.fncCalculateVat()))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "margin-top": "3px",
      "font-size": "12px !important",
      "border": "none !important",
      "background-color": "#fff !important",
      "background": "#fff !important",
      "color": "#000"
    }
  }, [(_vm.objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') !== -1) ? _c('td', {
    staticStyle: {
      "text-align": "right !important"
    },
    attrs: {
      "colspan": "7"
    }
  }, [_c('strong', [_vm._v("TOTAL PRICE")])]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') === -1) ? _c('td', {
    staticStyle: {
      "text-align": "right !important"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_c('strong', [_vm._v("TOTAL PRICE")])]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "totalprice-column",
    staticStyle: {
      "text-align": "right !important"
    }
  }, [_vm._v(_vm._s(_vm.fncFinalTotal()))])])]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.vendorActive == 1 && _vm.objAuthorize.manufacturer == '385889803') ? _c('template', {
    staticStyle: {
      "padding-bottom": "10px",
      "margin-top": "40px"
    },
    slot: "footer"
  }, [_c('tr', {
    staticStyle: {
      "font-size": "12px !important",
      "border": "none !important",
      "background-color": "#fff !important",
      "background": "#fff !important",
      "color": "#000"
    }
  }, [(_vm.objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') !== -1) ? _c('td', {
    staticStyle: {
      "text-align": "right !important"
    },
    attrs: {
      "colspan": "7"
    }
  }, [_c('strong', [_vm._v("TOTAL PRICE")])]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') === -1) ? _c('td', {
    staticStyle: {
      "text-align": "right !important"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("TOTAL PRICE")])]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "totalprice-column",
    staticStyle: {
      "text-align": "right !important"
    }
  }, [_vm._v(_vm._s(_vm.fncTotalNett()))])])]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '16777962') ? _c('template', {
    staticStyle: {
      "padding-bottom": "10px",
      "margin-top": "40px"
    },
    slot: "footer"
  }, [_c('tr', {
    staticStyle: {
      "font-size": "12px !important",
      "border": "none !important",
      "background-color": "#fff !important",
      "background": "#fff !important",
      "color": "#000"
    }
  }, [(_vm.objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') !== -1) ? _c('td', {
    staticStyle: {
      "text-align": "right !important"
    },
    attrs: {
      "colspan": "7"
    }
  }, [_c('strong', [_vm._v("TOTAL PRICE")])]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('BASKET_DISCOUNT_ACCESS') === -1) ? _c('td', {
    staticStyle: {
      "text-align": "right !important"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("TOTAL PRICE")])]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "totalprice-column",
    staticStyle: {
      "text-align": "right !important"
    }
  }, [_vm._v(_vm._s(_vm.fncTotalNett()))])])]) : _vm._e()], 2), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.lineData.installation_customer_first_name != null) ? _c('div', {
    staticClass: "lineItemDetails"
  }, [_c('br'), _c('br'), _c('h2', [_vm._v("Installation Details")]), _vm._v(" "), _c('table', {
    staticClass: "installation",
    attrs: {
      "cellpadding": "10",
      "width": "100%"
    }
  }, [_c('tr', [_c('th', {
    staticClass: "installation-header",
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("Customer Details")])])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("First Name")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("Last Name")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("Email Address")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("Contact Number")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_customer_first_name))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_customer_last_name))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_customer_email))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_customer_contact_number))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "installation",
    attrs: {
      "cellpadding": "10",
      "width": "100%"
    }
  }, [_c('tr', [_c('th', {
    staticClass: "installation-header",
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("Address Details")])])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "50%",
      "colspan": "2"
    }
  }, [_vm._v("Address Found")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "50%",
      "colspan": "2"
    }
  }, [_vm._v("Address Searched")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "50%",
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_address_found))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "50%",
      "colspan": "2"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_address_searched))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("Suburb")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("Province")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("Installation Lat")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("Installation Long")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_address_suburb))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_address_province))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_address_install_lat))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_address_install_long))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("Store Lat")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("Store Long")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("Store Name")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("Store Code")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_address_store_lat))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_address_store_long))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_address_store_name))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.store_id))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "installation",
    attrs: {
      "cellpadding": "10",
      "width": "100%"
    }
  }, [_c('tr', [_c('th', {
    staticClass: "installation-header",
    attrs: {
      "colspan": "5"
    }
  }, [_c('strong', [_vm._v("Install Details")])])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Appointment Date Start")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Appointment Date End")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Appointment Contact Number")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Appointment Contact Person")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Lookup Service Rep")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "20%"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.fncDisplayDate(_vm.lineData.installation_appointment_date_start))
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_appointment_date_end))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_appointment_contact_number))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_appointment_contact_person))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_lookup_service_ref))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "80%",
      "colspan": "4"
    }
  }, [_vm._v("Appointment Installation Notes")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Installation Sales Order Number")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "80%",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_notes))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_sales_order_number))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "installation",
    attrs: {
      "cellpadding": "10",
      "width": "100%"
    }
  }, [_c('tr', [_c('th', {
    staticClass: "installation-header",
    attrs: {
      "colspan": "6"
    }
  }, [_c('strong', [_vm._v("Product Details")])])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "16.66%"
    }
  }, [_vm._v("Product Description")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "16.66%"
    }
  }, [_vm._v("Product Make")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "16.66%"
    }
  }, [_vm._v("Product Type")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "16.66%"
    }
  }, [_vm._v("Product SKU")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "16.66%"
    }
  }, [_vm._v("Product MO ID")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "16.66%"
    }
  }, [_vm._v("Product QTY")])]), _vm._v(" "), (_vm.productCount >= 1) ? _c('tr', [_c('td', {
    attrs: {
      "width": "16.66%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_product_description_1))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "16.66%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_product_make_1))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "16.66%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_product_type_1))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "16.66%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_product_sku_1))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "16.66%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_product_moid_1))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "16.66%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_product_qty_1))])]) : _vm._e(), _vm._v(" "), (_vm.productCount >= 2) ? _c('tr', [_c('td', {
    attrs: {
      "width": "16.66%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_product_description_2))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "16.66%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_product_make_2))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "16.66%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_product_type_2))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "16.66%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_product_sku_2))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "16.66%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_product_moid_2))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "16.66%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_product_qty_2))])]) : _vm._e(), _vm._v(" "), (_vm.productCount >= 3) ? _c('tr', [_c('td', {
    attrs: {
      "width": "16.66%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_product_description_3))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "16.66%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_product_make_3))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "16.66%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_product_type_3))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "16.66%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_product_sku_3))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "16.66%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_product_moid_3))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "16.66%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_product_qty_3))])]) : _vm._e(), _vm._v(" "), (_vm.productCount >= 4) ? _c('tr', [_c('td', {
    attrs: {
      "width": "16.66%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_product_description_4))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "16.66%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_product_make_4))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "16.66%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_product_type_4))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "16.66%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_product_sku_4))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "16.66%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_product_moid_4))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "16.66%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_product_qty_4))])]) : _vm._e(), _vm._v(" "), (_vm.productCount >= 5) ? _c('tr', [_c('td', {
    attrs: {
      "width": "16.66%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_product_description_5))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "16.66%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_product_make_5))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "16.66%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_product_type_5))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "16.66%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_product_sku_5))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "16.66%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_product_moid_5))]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "16.66%"
    }
  }, [_vm._v(_vm._s(_vm.lineData.installation_product_qty_5))])]) : _vm._e()]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "lineItemDetails"
  }, [_c('div', {
    staticClass: "lineItemDetail",
    domProps: {
      "innerHTML": _vm._s(_vm.fncShowSpec(_vm.singleQuoteData.details))
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-4 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)])], 1)], 1)
},staticRenderFns: []}